<template>
  <SkeletonLoader
    v-if="accountStatusRequestStatus === RequestStatus.Loading"
    show-animation
    class="trade-status__loader"
    data-testid="trade-status-loader"
  >
    <div />
    <div />
  </SkeletonLoader>
  <ErrorHandler
    v-else-if="accountStatusRequestStatus === RequestStatus.Error"
    title="Desculpe, não conseguimos carregar o mercado"
    description="Aguarde alguns minutos e tente novamente."
    icon="ic_alert_error"
    @retry="handleTradeStatusRetryClick"
  />
  <Row
    v-else
    class="trade-status"
    :chevron="false"
    :has-interaction="false"
    :has-line="false"
  >
    <RoundedIcon
      slot="icon-left"
      data-testid="status-icon"
      :icon-name="setMarketIcon"
      icon-size="24"
      background-size="40"
      :main-color="NebraskaColors.statusAlertBackground"
      :text-color="NebraskaColors.statusAlert"
    />
    <template #top-left>
      <p class="text-p-3 trade-unavaliable_balance__title">
        {{ marketStatusFormatted }}
      </p>
    </template>
    <template #bottom-left>
      <p class="text-p-5 trade-unavaliable_balance__subtitle">
        {{ statusDescription }}
      </p>
    </template>
  </Row>
</template>
<script lang="ts">
import { namespace } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { ErrorHandler } from '@/modules/common/components/ErrorHandler';
import { Row, RoundedIcon, SkeletonLoader } from '@warrenbrasil/nebraska-web';

import { TradeMarketAvailable } from '@/modules/trade/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RequestStatus } from '@/modules/trade/store/trade';
import { trackMarketStatusRetryClick } from '@/modules/trade/views/TradeView/trackers';

const tradePositionsModule = namespace('tradeModule');

@Component({
  components: {
    Row,
    ErrorHandler,
    RoundedIcon,
    SkeletonLoader
  }
})
export default class TradeStatus extends Vue {
  @Prop({ type: Object, required: false })
  readonly status?: TradeMarketAvailable;

  @tradePositionsModule.State('accountStatusRequestStatus')
  readonly accountStatusRequestStatus!: RequestStatus;

  @tradePositionsModule.Action('fetchStatus')
  readonly fetchStatus!: Function;

  readonly RequestStatus = RequestStatus;

  get NebraskaColors() {
    return NebraskaColors;
  }

  get marketStatusFormatted() {
    return this.status?.marketStatus?.formatted;
  }

  get statusDescription() {
    return this.status?.description;
  }

  get setMarketIcon() {
    const marketType = String(this.status?.marketStatus?.value);
    if (marketType === 'MARKET_UNAVAILABLE') {
      return 'ic_alert';
    }
    if (marketType === 'MARKET_HOLIDAY') {
      return 'ic_calendar_2';
    }

    return 'ic_watch_warning';
  }

  async handleTradeStatusRetryClick() {
    trackMarketStatusRetryClick();
    await this.fetchStatus();
  }
}
</script>

<style lang="less" scoped>
.error-handler {
  padding: @size-spacing-x450 @size-spacing-x400 !important;
}

.trade-status {
  margin-bottom: @size-spacing-x400;

  &__loader {
    div {
      width: 20%;
      height: 35px;
      border-radius: @size-radius-x200;
      &:first-of-type {
        width: 40%;
        margin: @size-spacing-x600 0;
      }
      &:last-of-type {
        margin-top: @size-spacing-x350;
        height: 20px;
      }
    }
  }
}

.trade-unavaliable_balance__title {
  color: @text-primary;
}

.trade-unavaliable_balance__subtitle {
  color: @text-secondary;
}
</style>
